"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var styles = {
  subject: {
    fontSize: 22,
    fontFamily: 'Roboto, sans-serif'
  },
  sender: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    fontWeight: 'bold'
  },
  recipient: {
    fontSize: 12,
    fontFamily: 'Roboto, sans-serif',
    '&::after': {
      content: "''",
      display: 'inline-block',
      borderTop: '3px solid transparent',
      borderRight: '3px solid #808080',
      borderBottom: '3px solid #808080',
      borderLeft: '3px solid transparent',
      transform: 'rotate(45deg)',
      position: 'relative',
      top: -3,
      left: 6
    }
  }
};

var EmailPreview = function EmailPreview(_ref) {
  var subject = _ref.subject,
      body = _ref.body,
      senderFullName = _ref.senderFullName;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 3,
    pl: 3,
    pr: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 4
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.subject
  }, subject)), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.sender
  }, senderFullName), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.recipient
  }, "to me")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: body
    }
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(EmailPreview);

exports.default = _default;